export default __webpack_public_path__ + "static/media/bag2.ca181bd3.png";